import React from "react";
import PlacementsForm from "../../../components/forms/Campaign/PlacementsForm";
import SettingsCard from "./SettingsCard";

const AdvancedPlacements = () => {
  return (
    <SettingsCard
      title="Placements"
      description="A list of traffic driving Placements."
    >
      <PlacementsForm className="mt-8" />
    </SettingsCard>
  );
};

export default AdvancedPlacements;
